import { getOrgDataFromLocalStorage } from '@app/helpers/navigation';
import { getUserReportsAvailableCore } from '@westondev/tableturn-core';
import { RootState } from '../store';

export const selectIsReportsModuleAvailable = (state: RootState) => {
  const roleId = getOrgDataFromLocalStorage()?.roleId ?? 0;
  return getUserReportsAvailableCore(state, roleId);
};
